module.exports = __webpack_public_path__ + "img/imagen8.28737ea1.png";